/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.org/docs/browser-apis/
 */

const invokeClick = (elem) => {
  // Create our event (with options)
  var evt = new MouseEvent("click", {
    bubbles: true,
    cancelable: true,
    view: window,
  })
  // If cancelled, don't dispatch our event
  // eslint-disable-next-line
  var canceled = !elem.dispatchEvent(evt)
}

const autoInvokeSelectedAnchorItem = (delay = 300) => {
  // Only search for an element with the id of the hash if the hash is a valid id
  if (window.location.hash && /^#[\w-]+$/.exec(window.location.hash)) {
    const destinationElement = document.querySelector(window.location.hash)
    if (destinationElement && destinationElement.classList.contains(
      "c-Accordion-item")) {
      window.setTimeout(function() {
        invokeClick(destinationElement.children[0])
      }, delay)
    }
  }
}

const invokePersonalistationJs = (delay = 500) => {
  window.setTimeout(function() {
    if (window.onload) {
      window.onload()
    }
  }, delay)
}

const scrollToCoord = (top) => {
  if (window.ieVersion() === 0) {
    window.scroll({ behavior: "smooth" }, top)
  } else {
    window.scroll(0, top)
  }
}

const scrollToHref = (href) => {
  // destination element to scroll to
  const destinationElement = document.querySelector(href)
  if (destinationElement) {
    window.setTimeout(function() {
      const topCoord =
        destinationElement.getBoundingClientRect().top + window.scrollY - 80
      scrollToCoord(topCoord)
    }, 300)
  }
}

const scroll = {
  toCoord: scrollToCoord,
  toHref: scrollToHref,
}

const saveUsersScrollPosition = () => {
  if (window.sessionStorage && window.sessionStorage.setItem) {
    window.sessionStorage.setItem(
      `@@users-scroll|${document.location.pathname}|initial`,
      window.scrollY,
    )
    return true
  }
  return false
}

const restoreUsersScrollPosition = (path) => {
  if (window.sessionStorage && window.sessionStorage.getItem) {
    window.clearTimeout(window.scrollFixTimeout)
    let lastSavedScroll = window.sessionStorage.getItem(
      `@@users-scroll|${path}|initial`,
    )
    window.scrollFixTimeout = window.setTimeout(function() {
      // console.log(
      //   "DEBUG: restoreUsersScrollPosition window.scrollTo ",
      //   lastSavedScroll
      // )
      window.scrollTo(0, lastSavedScroll)
    }, 1000)
    return true
  }
  return false
}

const initPersonalisation = () => {
  // inject Scripts only when not in previewMode
  if (document.location.search.indexOf("previewMode=true") === -1) {
    if (process.env.NODE_ENV === "development") {
      invokePersonalistationJs()
    }
  }

  window.addEventListener("hashchange", function(evt) {
    if (window.location.hash) {
      invokePersonalistationJs()
    }
  })
}

const initIEVersion = () => {
  window.ieVersion = function() {
    var ua = window.navigator.userAgent
    if (ua.indexOf("Trident/7.0") > -1) {
      return 11
    } else if (ua.indexOf("Trident/6.0") > -1) {
      return 10
    } else if (ua.indexOf("Trident/5.0") > -1) {
      return 9
    } else {
      return 0 // not IE9, 10 or 11
    }
  }
}

const initScrollHandling = (excludeScrollHandling) => {
  if (window.location.hash) {
    // introduce scroll offset since sticky header might cover the element
    window.setTimeout(function() {
      scroll.toHref(window.location.hash)
      // TODO-check: Is this related to the scrolling? Why do we need that here?
      invokePersonalistationJs()
    }, 300)
  }

  window.addEventListener("hashchange", function(evt) {
    if (window.location.hash) {
      window.setTimeout(function() {
        scroll.toHref(window.location.hash)
      }, 50)
    } else {
      // no hash, meaning window has moved from path#hash to path, scroll to the very top
      scroll.toCoord(0)
    }
    evt.preventDefault()
  })

  if (!excludeScrollHandling) {
    // custom handler to save last pages last scroll position when navigating without gatsby-links (unload-Event)
    window.addEventListener("unload", function() {
      saveUsersScrollPosition()
    })

    window.addEventListener("load", function() {
      if (window.location.hash === "") {
        restoreUsersScrollPosition(document.location.pathname)
      }
    })
  }
}

exports.onInitialClientRender = (_, pluginOptions) => {
  initIEVersion()
  initPersonalisation()
  initScrollHandling(pluginOptions?.excludeScrollHandling)
  autoInvokeSelectedAnchorItem(600) // TODO-check: is it really important that it is done after scroll.toHref?
}

exports.shouldUpdateScroll = ({ routerProps: { location } }, pluginOptions) => {
  if (window.upgradeAllBehaviours) {
    window.upgradeAllBehaviours()
    autoInvokeSelectedAnchorItem()
  }

  if (pluginOptions?.excludeScrollHandling !== true && window.location.hash === "") {
    restoreUsersScrollPosition(location.pathname)
  }

  invokePersonalistationJs()

  return false
}
